import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
  GET_SERVICE_FEES_SUCCESS,
  BOOKING_PAYMENT_START,
  BOOKING_PAYMENT_SUCCESS,
  BOOKING_PAYMENT_ERROR,  
  BOOKING_PAYMENT_FOR_CANCEL_START,
  BOOKING_PAYMENT_FOR_CANCEL_ERROR,
  SET_BILLING_CALCULATION,
  CLEAR_BILLING_CALCULATION,
  SET_BILLING_REQUEST_KEY,
} from '../constants';

export default function book(state = {}, action) {
  switch (action.type) {

    case BOOKING_PROCESS_START:
      return {
        ...state,
        data: null,
        bookDetails: null,
        bookingLoading: action.payload.bookingLoading,
      };
      
    case BOOKING_PROCESS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        bookDetails: action.payload.bookDetails,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PROCESS_ERROR:
      return {
        ...state,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PAYMENT_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      }; 

    case BOOKING_PAYMENT_ERROR:
    return {
      ...state,
      paymentLoading: action.payload.paymentLoading,
    }; 

    case BOOKING_PAYMENT_FOR_CANCEL_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_FOR_CANCEL_ERROR:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };
      
    case GET_SERVICE_FEES_SUCCESS:
      return {
        ...state,
        serviceFees: action.payload.serviceFees,
      };

    case SET_BILLING_REQUEST_KEY:
      return {
        ...state,
        billingRequestKey: action.payload.billingRequestKey,
        billingListId: action.payload.billingListId,
        // Drop prior totals as soon as a new fetch starts so a new listId cannot
        // match stale checkIn/checkOut from the previous listing.
        billingCalculation: null,
        appliedPromoCode: null,
      };

    case SET_BILLING_CALCULATION:
      return {
        ...state,
        billingCalculation: action.payload.billingCalculation,
        appliedPromoCode: action.payload.appliedPromoCode,
        billingListId: action.payload.billingListId,
      };

    case CLEAR_BILLING_CALCULATION:
      return {
        ...state,
        billingCalculation: null,
        appliedPromoCode: null,
        billingListId: null,
        billingRequestKey: null,
      };

    default:
      return state;
  }
}